const initialState = {identityDocuments: []}

export const identityDocuments = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_IDENTITY_DOCUMENTS':
      return {identityDocuments: action.payload}; 
  }
  return state
}


